export const Text = (() => {
	'use strict';

	function init() {
	}

	return {
		init: init,
	};
})();
